export default __webpack_public_path__ + "media/images/logos/mosaic-logo-43da0c0520231bcfda174091902b14cf.svg";